import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import { COMPARISON, BOGLE_LIGHT } from '../../constants/constant';
import { useStyles, styles, selectStyleMenu } from './styles';
import PropTypes from 'prop-types';

const Comparison = ({ getComparisonSelected, operation }) => {
	const classes = useStyles();

	const [comparison, setComparison] = useState(
		operation === 'LessThanEquals' ? 'A lesser than B' : 'A greater than B'
	);

	const handleComparisonChange = (event) => {
		const value = event.target.value;
		setComparison(value);
		getComparisonSelected(value);
	};

	return (
		<Box>
			<FormControl sx={{ ...styles.metricSelect, ...styles.outline }}>
				<InputLabel id="cb-label" sx={{ ...styles.textField }}>
					{COMPARISON}
				</InputLabel>
				<Select
					id="Comparison"
					value={comparison}
					label="Comparison"
					onChange={handleComparisonChange}
					fullWidth
					sx={{
						fontFamily: BOGLE_LIGHT,
						fontSize: 14,
					}}
					MenuProps={{
						sx: selectStyleMenu,
						disablePortal: true,
					}}>
					<MenuItem className={classes.menuItems} value={'A greater than B'}>
						A greater than B
					</MenuItem>
					<MenuItem className={classes.menuItems} value={'A lesser than B'}>
						A is less than B
					</MenuItem>
				</Select>
			</FormControl>
		</Box>
	);
};

Comparison.propTypes = {
	getComparisonSelected: PropTypes.func,
	operation: PropTypes.string,
};

export default Comparison;
